export default __webpack_public_path__ + "static/media/2.ca01ecca.jpg";